import { TopBar } from "@/components/layout/TopBar";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <TopBar />
      <div className="flex shrink-0 grow items-stretch gap-x-3 xl:gap-x-6">
        <Outlet />
      </div>
    </>
  );
}
